import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';

//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";

const ProfileDropdown = () => {


    const profiledropdownData = createSelector(
        (state) => state.Profile,
        (state) => ({
            user: state.user
        })
      );
    // Inside your component
    const {user} = useSelector(profiledropdownData);

    const [userName, setUserName] = useState("Admin");

    useEffect(() => {
        if (localStorage.getItem("authUser")) {
            try {
                const obj = JSON.parse(localStorage.getItem("authUser"));
                let name = "Admin";
                
                // Check if using API authentication (new structure)
                if (process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_DEFAULTAUTH === "api") {
                    // API response structure: { token, refreshToken, thirdPartyToken, user: { firstName, lastName, email, ... } }
                    if (obj?.user) {
                        // Support both camelCase (API) and snake_case (legacy)
                        name = obj.user.firstName || obj.user.first_name || obj.user.email || "Admin";
                    } else if (obj?.email) {
                        name = obj.email;
                    }
                } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
                    // Fake/Mock authentication structure
                    if (obj?.username) {
                        name = obj.username;
                    } else if (user && user?.first_name) {
                        name = user.first_name;
                    } else if (obj?.data?.first_name) {
                        name = obj.data.first_name;
                    } else if (obj?.data?.firstName) {
                        name = obj.data.firstName;
                    }
                } else if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
                    // Firebase authentication
                    name = obj?.email || "Admin";
                } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
                    // JWT authentication - check Redux state first, then localStorage
                    if (user?.firstName) {
                        name = user.firstName;
                    } else if (user?.first_name) {
                        name = user.first_name;
                    } else if (obj?.user?.firstName) {
                        name = obj.user.firstName;
                    } else if (obj?.user?.first_name) {
                        name = obj.user.first_name;
                    } else if (obj?.email) {
                        name = obj.email;
                    }
                } else {
                    // Default fallback - try to get name from various possible structures
                    if (user?.firstName) {
                        name = user.firstName;
                    } else if (user?.first_name) {
                        name = user.first_name;
                    } else if (obj?.user?.firstName) {
                        name = obj.user.firstName;
                    } else if (obj?.user?.first_name) {
                        name = obj.user.first_name;
                    } else if (obj?.data?.firstName) {
                        name = obj.data.firstName;
                    } else if (obj?.data?.first_name) {
                        name = obj.data.first_name;
                    } else if (obj?.email) {
                        name = obj.email;
                    }
                }
                
                setUserName(name);
            } catch (error) {
                console.error("Error parsing authUser from localStorage:", error);
                setUserName("Admin");
            }
        }
    }, [user]);

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    // Logout confirmation modal
    const [logoutModal, setLogoutModal] = useState(false);
    const navigate = useNavigate();

    const toggleLogoutModal = () => {
        setLogoutModal(!logoutModal);
        // Close profile dropdown when opening/closing logout modal
        setIsProfileDropdown(false);
    };

    const handleLogoutConfirm = () => {
        setLogoutModal(false);
        navigate('/logout');
    };
    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn" data-readonly-allow>
                    <span className="d-flex align-items-center">
                        <img className="rounded-circle header-profile-user" src={avatar1}
                            alt="Header Avatar" />
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{userName}</span>
                            {/* <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">Founder</span> */}
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end" data-readonly-allow>
                    <h6 className="dropdown-header">Welcome {userName}!</h6>
                    <DropdownItem className='p-0'>
                        <Link to="/profile" className="dropdown-item" data-readonly-allow>
                            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Profile</span>
                        </Link>
                    </DropdownItem>
                    {/* <DropdownItem className='p-0'>
                        <Link to="/apps-chat" className="dropdown-item">
                            <i className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i> <span
                                className="align-middle">Messages</span>
                        </Link>
                    </DropdownItem> */}
                    {/* <DropdownItem className='p-0'>
                        <Link to="#" className="dropdown-item">
                            <i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i> <span
                                className="align-middle">Taskboard</span>
                        </Link>
                    </DropdownItem> */}
                    {/* <DropdownItem className='p-0'>
                        <Link to="/pages-faqs" className="dropdown-item">
                            <i
                                className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle">Help</span>
                        </Link>
                    </DropdownItem> */}
                    <div className="dropdown-divider"></div>
                    {/* <DropdownItem className='p-0'>
                        <Link to="/pages-profile" className="dropdown-item">
                            <i
                                className="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle">Balance : <b>$5971.67</b></span>
                        </Link>
                    </DropdownItem > */}
                    {/* <DropdownItem className='p-0'>
                        <Link to="/pages-profile-settings" className="dropdown-item">
                            <span
                                className="badge bg-success-subtle text-success mt-1 float-end">New</span><i
                                    className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i> <span
                                        className="align-middle">Settings</span>
                        </Link>
                    </DropdownItem> */}
                    {/* <DropdownItem className='p-0'>
                        <Link to="/auth-lockscreen-basic" className="dropdown-item">
                            <i
                                className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Lock screen</span>
                        </Link>
                    </DropdownItem> */}
                    <DropdownItem className='p-0'>
                        <div 
                            onClick={toggleLogoutModal} 
                            className="dropdown-item cursor-pointer"
                            data-readonly-allow
                        >
                            <i
                                className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle" data-key="t-logout">Logout</span>
                        </div>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>

            {/* Logout Confirmation Modal */}
            <Modal isOpen={logoutModal} toggle={toggleLogoutModal} centered data-readonly-allow>
                <ModalHeader toggle={toggleLogoutModal}>
                    Confirm Logout
                </ModalHeader>
                <ModalBody>
                    <div className="text-center">
                        <lord-icon 
                            src="https://cdn.lordicon.com/gsqxdxog.json" 
                            trigger="loop"
                            colors="primary:#f7b84b,secondary:#f06548" 
                            className="lord-icon-large"
                        ></lord-icon>
                        <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                            <h4>Are you sure?</h4>
                            <p className="text-muted mx-4 mb-0">
                                Are you sure you want to logout? You will need to login again to access your account.
                            </p>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="light" onClick={toggleLogoutModal} data-readonly-allow>
                        Cancel
                    </Button>
                    <Button color="danger" onClick={handleLogoutConfirm} data-readonly-allow>
                        Logout
                    </Button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
};

export default ProfileDropdown;